import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_turnos/Crear_turno/Crear_turno.html?vue&type=template&id=3c436735&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_turnos/Crear_turno/Crear_turno.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_turnos/Crear_turno/Crear_turno.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_turnos/Crear_turno/Crear_turno.css?vue&type=style&index=0&id=3c436735&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c436735",
  null
  
)

export default component.exports